import { FC } from 'react';

import { HeroBanner } from '@purpur/library';

import { LandingPageBreadcrumbs } from '@telialt/public-web-content/src/components/Common/LandingPageBreadcrumbs/LandingPageBreadcrumbs';

import { useCategoryLocation } from '../../../hooks/useCategoryLocation';

type Props = { currentCategoryName: string; currentCategoryUrl: string };

export const TopBanner: FC<Props> = ({ currentCategoryName, currentCategoryUrl }) => {
    const { pathname } = useCategoryLocation();

    return (
        <HeroBanner
            title={currentCategoryName}
            headingTag="h1"
            breadcrumbs={
                <LandingPageBreadcrumbs
                    negative={true}
                    currentPath={pathname}
                    knownBreadcrumbs={[{ title: currentCategoryName, url: currentCategoryUrl }]}
                />
            }
        />
    );
};
